import { render } from "./ai-toolbar-demo.vue?vue&type=template&id=89ad497a"
import script from "./ai-toolbar-demo.vue?vue&type=script&setup=true&lang=js"
export * from "./ai-toolbar-demo.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/demo/ai-toolbar/ai-toolbar-demo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "89ad497a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('89ad497a', __exports__)) {
    api.reload('89ad497a', __exports__)
  }
  
  module.hot.accept("./ai-toolbar-demo.vue?vue&type=template&id=89ad497a", () => {
    api.rerender('89ad497a', render)
  })

}


export default __exports__